import React, { useMemo } from "react";
import WorkerProfileEditor from "../../screens/worker/WorkerProfileEditor";
import VStack from "../../ui_atoms/VStack";
import { MockedProvider } from "@apollo/client/testing";
import { MockedAuthManager } from "../../contexts/AuthManager";
import { buildUser, buildWorkerProfile } from "../factories";
import type { Meta, StoryObj } from "@storybook/react";
import { EducationLevel, ProfileType, WorkingPermit } from "../../__generated__/graphql";
import { MockedProfileSwitcherManager } from "../../contexts/ProfileSwitcherManager";

function StoryComponent() {
    const user = useMemo(
        () =>
            buildUser({
                workPermit: WorkingPermit.PermitB,
                workerProfile: buildWorkerProfile({
                    educationLevel: EducationLevel.TeachingCertificate,
                }),
            }),
        [],
    );
    return (
        <MockedProvider mocks={[]}>
            <MockedAuthManager user={user}>
                <MockedProfileSwitcherManager profileType={ProfileType.Worker}>
                    <VStack
                        gap={1}
                        style={{ alignItems: "stretch", alignSelf: "stretch", flex: 1 }}
                    >
                        <WorkerProfileEditor />
                    </VStack>
                </MockedProfileSwitcherManager>
            </MockedAuthManager>
        </MockedProvider>
    );
}

const meta = {
    title: "Screens/Worker profile",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
